/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import IconFamilyLaw from "../../assets/icons/familyLaw/IconDocumentSignpost";
import IconSuitCase from "../../assets/icons/generic/IconSuitCase";
import IconTrafficLaw from "../../assets/icons/traffic/IconTrafficLaw";

const linkedCardsHomePage = [
  {
    icon: IconFamilyLaw,
    heading: "Familienrecht",
    subHeading: "Wir führen Sie Schritt für Schritt durch Ihre Scheidung",
    link: "/servicewelt",
  },
  {
    icon: IconSuitCase,
    heading: "Arbeitsrecht",
    subHeading: "Professionelle & schnelle Hilfe bei Kündigungen",
    link: "/servicewelt",
  },
  {
    icon: IconTrafficLaw,
    heading: "Verkehrsrecht",
    subHeading: "Bußgeldbescheid? Nicht einfach zahlen, sondern kostenfrei prüfen lassen!",
    link: "/servicewelt",
  },
];

export default linkedCardsHomePage;
